module.exports = __webpack_public_path__ + "img/613.0be9fce3.jpg";